
const axios = require('axios');


export async function getConfig() {
    let resData = [];
    await axios.get("data/config.json")
        .then(res => {
            resData = res.data;
        });
    return resData;
}